import React, { useState } from "react";
//import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import MuiList from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import getStyled from "../../hooks/getStyled";
import _ from "lodash";
import { SFStack } from "../grid";
import { SFCopilotIcon } from "../icons";

const { styled } = getStyled();
const INNER_MENU_WIDTH = "100%";
const INNER_MENU_COLLAPSED_WIDTH = 64;

const MenuContainer = styled(MuiList, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  borderTop: `1px solid ${theme.palette.grey225.main}`,
  paddingTop: 0,
  flexGrow: 1,
  overflowY: "auto",
  overflowX: "hidden",
}));

const StyledMenuItem = styled(ListItem, {
  shouldForwardProp: (prop) =>
    prop !== "open" && prop !== "highlightedSelected",
})(({ theme, open }) => ({
  "& .MuiListItemButton-root": {
    padding: "10px 20px",
    "&:hover": {
      "& .MuiListItemIcon-root": {
        color: theme.palette.grey450.main,
      },
      backgroundColor: theme.palette.blue50.main,
      "& .MuiTypography-root": {
        color: theme.palette.grey450.main,
      },
    },
    "& .MuiListItemIcon-root": {
      minWidth: "40px",
    },
    "& .MuiTypography-root": {
      ...theme.typography.menuItemText,
      color: theme.palette.grey400.main,
    },
  },
  "&.Mui-selected": {
    backgroundColor: theme.palette.blue50.main,
    "& .MuiListItemIcon-root": {
      color: theme.palette.grey450.main,
    },
    "& .MuiTypography-root": {
      //color: theme.palette.grey450.main,
      color: theme.palette.grey450.main,
    },
    "& .MuiListItemButton-root": {
      "&:hover": {
        backgroundColor: theme.palette.blue50.main,
      },
    },
  },
  "& .MuiIconButton-root": {
    color: theme.palette.grey400.main,
  },
}));

export const MenuItem = ({
  label,
  selected,
  highlightedSelected,
  onClick,
  onMouseOver,
  icon,
  open,
  hasChildren = false,
  isOpen = false,
  showCopilotIcon = false,
  ...props
}) => (
  <StyledMenuItem
    {...props}
    highlightedSelected={highlightedSelected}
    disablePadding
    onClick={onClick}
    onMouseOver={onMouseOver}
    selected={selected}
  >
    <ListItemButton open={open}>
      {!open && <ListItemIcon sx={{ marginLeft: "3px" }}>{icon}</ListItemIcon>}
      {open && (
        <SFStack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
        >
          <SFStack direction="row" alignItems="center">
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText primary={label} />
          </SFStack>
          {showCopilotIcon && <SFCopilotIcon size="small" color="blue500" />}
        </SFStack>
      )}
    </ListItemButton>
  </StyledMenuItem>
);

const SFInnerMenu = ({
  onClick,
  items,
  menuOpen = true,
  disableTracking = false,
  currentMenu = null,
}) => {
  const [currentMenuId, setCurrentMenuId] = useState(null);

  const onMenuClick = (item) => {
    if (!disableTracking) {
      setCurrentMenuId(item.id);
    }
    onClick(item);
  };

  return (
    <MenuContainer
      sx={{ width: menuOpen ? INNER_MENU_WIDTH : INNER_MENU_COLLAPSED_WIDTH }}
    >
      {_.map(
        _.filter(items, (i) => i.showInMenu),
        (i) => (
          <MenuItem
            key={i.id}
            label={i.title}
            icon={i.icon}
            onClick={() => onMenuClick(i)}
            open={menuOpen}
            selected={i.id == currentMenuId || i.id == currentMenu}
            showCopilotIcon={i.showCopilotIcon}
          />
        )
      )}
    </MenuContainer>
  );
};

SFInnerMenu.propTypes = {
  items: PropTypes.any,
  onClick: PropTypes.func.isRequired,
  menuOpen: PropTypes.bool,
  // routes: PropTypes.arrayOf(
  //   PropTypes.shape({
  //     label: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(Trans)])
  //       .isRequired,
  //     path: PropTypes.string.isRequired,
  //     icon: PropTypes.element.isRequired,
  //     location: PropTypes.oneOf(["main", "footer"]),
  //   }).isRequired
  // ),
};

export default SFInnerMenu;
